import { Link, useLocation, useNavigate, useParams } from "react-router";
import { my_routes } from "../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getFileValidationByEntity } from "../../api/fileAttachement";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";
import CancelDiplome from "./cancelDiplome";
import {
  generateNewDiplome,
  getDecisionParameter,
  getDiplomeById,
  getDiplomeFile,
  regenerateDiplome,
  updateDiplome,
} from "../../api/diplome";
import DiplomeValidationModal from "./DiplomeValidationModal";
import { useSelector } from "react-redux";

//bouton proteger pour supprimer le fichier du proces verbale
const ProtectedBtnCancelDiplome = withPermission(
  (props: any) => (
    <button
      className="btn btn-sm btn-outline-danger"
      onClick={props.cancelDiplomeAlert}
    >
      <i className="ti ti-trash" /> Annuler le diplôme
    </button>
  ),
  [buildPermission(Resource.DIPLOME, Action.DELETE)],
  "masquer",
);

const ProtectedBtnRegenerateDiplome = withPermission(
  (props: any) => (
    <button
      className="btn btn-sm btn-success"
      onClick={props.regenerateDiplomeAlert}
    >
      <i className="ti ti-refresh" /> Regénérer le diplôme
    </button>
  ),
  [buildPermission(Resource.DIPLOME, Action.UPDATE)],
  "masquer",
);

const ProtectedBtnGenerateDiplome = withPermission(
  (props: any) => (
    <button className="btn btn-success" onClick={props.generateDiplomeAlert}>
      <i className="ti ti-clipboard-data me-2" /> Générer le diplôme
    </button>
  ),
  [buildPermission(Resource.DIPLOME, Action.CREATE)],
  "masquer",
);

const ProtectedBtnSendDiplomeForValidation = withPermission(
  (props: any) => (
    <button className="btn btn-success" onClick={props.validateDiplomeAlert}>
      <i className="ti ti-clipboard-data me-2" /> Soumettre pour validation
    </button>
  ),
  [buildPermission(Resource.DIPLOME, Action.UPDATE)],
  "masquer",
);

const DiplomeDetails = () => {
  const routes = my_routes;
  const location = useLocation();
  // === SweetAlert (confirmations) ===
  const MySwal = withReactContent(Swal);

  const navigate = useNavigate();

  // === Paramètres d'URL ===
  const { id, idDecision } = useParams(); // On récupère l'id de l'URL

  // === States principaux ===
  const [diplomeDetail, setDiplomeDetail] = useState<any>(null);
  const [diplomeFile, setDiplomeFile] = useState<any>(null);
  const [decisionParameter, setDecisionParameter] = useState<any>(null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [iframeSrc, setIframeSrc] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données
  const [showValidationModal, setShowValidationModal] = useState(false);

  const userData = useSelector((state: any) => state.auth.user);

  // === Reload global (à éviter si possible) ===
  type DiplomeRefreshScope = "all" | "status" | "details" | "file";

  useEffect(() => {
    // On attend que id soit défini
    if (!id) return;

    fetchDiplomeDetails(true, ["all"]);
    fetchDecisionParameter();

    return () => {
      // nettoyage quand on quitte la page
      setIframeSrc("");
      setDiplomeFile(null);
    };
  }, [id]);

  const fetchDiplomeDetails = async (
    showPageLoader = false,
    scopes: DiplomeRefreshScope[] = ["all"],
  ) => {
    try {
      if (showPageLoader) {
        setIsLoading(true);
      }

      const response = await getDiplomeById(
        id,
        buildPermissionContext(Resource.DIPLOME, Action.READ),
      );
      const diplomeData = response.data || [];

      if (scopes.includes("all")) {
        setDiplomeDetail(diplomeData);
      }

      if (scopes.includes("status")) {
        setDiplomeDetail((prev: any) => ({
          ...prev,
          statut: diplomeData.statut,
          date_generation: diplomeData.date_generation,
          Validation: diplomeData.Validation,
        }));
      }

      if (scopes.includes("details")) {
        setDiplomeDetail((prev: any) => ({
          ...prev,
          ...diplomeData,
        }));
      }

      if (scopes.includes("file") || scopes.includes("all")) {
        const diplomeFile = await getDiplomeFile(id, "Diploma");

        if (!diplomeFile?.data?.length) {
          setIframeSrc("");
          setDiplomeFile(null);
        } else {
          setDiplomeFile(diplomeFile.data[0]);
          setIframeSrc(diplomeFile.data[0].temporaryUrl);
        }
      }
    } catch (error: any) {
      // console.log("erreur de chargement du diplôme : ", error);
      toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Une erreur s'est produit, Réessayer plus tard",
      );

      if (showPageLoader) {
        setDiplomeDetail(null);
      }
    } finally {
      if (showPageLoader) {
        setIsLoading(false);
      }

      setHasLoaded(true);
    }
  };

  const fetchDecisionParameter = async () => {
    try {
      const response = await getDecisionParameter();
      if (!response) {
        // Si aucune année trouvé
        throw new Error("Paramètres introuvable");
      }
      // console.log("Paramètres", response.data)
      setDecisionParameter(response.data.decisionParameter);
    } catch (error: any) {
      // Si erreur (Toast Error)
      toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const getDiplomeStatutBadge = (statut?: string) => {
    switch (statut) {
      case "Généré":
        return { className: "bg-soft-success", label: "Généré", icon: "✅" };
      case "En Attente":
        return {
          className: "bg-soft-warning",
          label: "En Attente",
          icon: "⏳",
        };
      case "En cours de validation":
        return {
          className: "bg-soft-info",
          label: "En cours de validation",
          icon: "🕒",
        };
      case "Validé":
        return { className: "bg-soft-success", label: "Validé", icon: "✅" };
      case "Annulé":
        return { className: "bg-soft-danger", label: "Annulé", icon: "❌" };
      default:
        return {
          className: "bg-soft-secondary",
          label: statut || "Inconnu",
          icon: "•",
        };
    }
  };

  const getDiplomeValidationBadge = (statut?: string) => {
    switch (statut) {
      case "Validé":
        return {
          className: "bg-soft-success text-success",
          cardClassName: "border-success bg-soft-success",
          icon: "ti ti-shield-check",
          label: "Validé",
          dateLabel: "Date de validation",
          supportBtnClassName: "btn-success",
        };
      case "Rejeté":
        return {
          className: "bg-soft-danger text-danger",
          cardClassName: "border-danger bg-soft-danger",
          icon: "ti ti-shield-x",
          label: "Rejeté",
          dateLabel: "Date de rejet",
          supportBtnClassName: "btn-outline-danger",
        };
      default:
        return {
          className: "bg-soft-secondary text-muted",
          cardClassName: "border bg-light",
          icon: "ti ti-shield-question",
          label: statut || "Statut inconnu",
          dateLabel: "Date",
          supportBtnClassName: "btn-outline-secondary",
        };
    }
  };

  const cancelDiplomeAlert = () => {
    MySwal.fire({
      title: "Souhaitez vous annuler ce diplôme ?",
      text: "Voulez-vous vraiment annuler ce diplôme ?",
      showCancelButton: true,
      confirmButtonText: "Annuler le diplôme",
      cancelButtonText: "Retour",
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        setShowCancelModal(true);
      }
    });
  };

  const regenerateDiplomeAlert = () => {
    MySwal.fire({
      title: "Regénérer le diplôme ?",
      text: "Voulez-vous vraiment regénérer ce diplôme ? Assurez-vous que les erreurs ayant conduit à l'annulation du diplôme ont été corrigées avant de procéder.",
      showCancelButton: true,
      confirmButtonText: "Regénérer",
      cancelButtonText: "Annuler",
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Regénération en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          await regenerateDiplome(
            diplomeDetail?.id,
            buildPermissionContext(Resource.DIPLOME, Action.CREATE),
          );

          MySwal.fire("Regénéré !", "Diplôme regénéré.", "success");
        } catch (error) {
          // console.log(error)
          MySwal.fire("Erreur", "Impossible de regénérer le diplôme.", "error");
        }
      }
    });
  };

  const validateDiplomeAlert = () => {
    MySwal.fire({
      title: "Soumettre le diplôme pour validation ?",
      text: "Voulez-vous vraiment soumettre ce diplôme pour validation ? Assurez-vous que les erreurs ayant conduit à l'annulation du diplôme ont été corrigées avant de procéder.",
      showCancelButton: true,
      confirmButtonText: "Soumettre",
      cancelButtonText: "Annuler",
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Soumission pour validation en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          const response = await updateDiplome(
            diplomeDetail?.id,
            buildPermissionContext(Resource.DIPLOME, Action.UPDATE),
          );

          fetchDiplomeDetails(true, ["status"]);
          MySwal.fire("Soumis !", "Diplôme soumis pour validation.", "success");
        } catch (error) {
          // console.log(error)
          MySwal.fire(
            "Erreur",
            "Impossible de soumettre le diplôme pour validation.",
            "error",
          );
        }
      }
    });
  };

  const generateDiplomeAlert = () => {
    MySwal.fire({
      title: "Lancer la génération du diplôme ?",
      text: "Voulez-vous vraiment lancer la génération de ce diplôme ?",
      showCancelButton: true,
      confirmButtonText: "Lancer la génération",
      cancelButtonText: "Annuler",
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Génération du diplôme en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          const response = await generateNewDiplome(
            idDecision,
            id,
            buildPermissionContext(Resource.DIPLOME, Action.CREATE),
          );
          // console.log("Réponse de la génération : ", response);
          fetchDiplomeDetails(true, ["status", "file"]);
          MySwal.fire("Généré !", "Diplôme généré.", "success");
        } catch (error) {
          // console.log(error)
          MySwal.fire("Erreur", "Impossible de générer le diplôme.", "error");
        }
      }
    });
  };

  // === Voir / Télécharger un support ===

  const handleDownloadDiplomeFile = async () => {
    try {
      if (!diplomeFile?.temporaryUrl) {
        toast.error("Fichier du diplôme introuvable.");
        return;
      }

      const response = await fetch(diplomeFile.temporaryUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download =
        diplomeFile?.fileOriginalName ||
        diplomeFile?.filename ||
        `diplome-${diplomeDetail?.number || id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.log("Erreur lors du téléchargement du diplôme :", error);

      if (diplomeFile?.temporaryUrl) {
        window.open(diplomeFile.temporaryUrl, "_blank", "noopener,noreferrer");
        return;
      }

      toast.error("Impossible de télécharger le diplôme.");
    }
  };

  const handleGetValidationSupport = async () => {
    try {
      const validationId = diplomeDetail?.Validation?.id;

      if (!validationId) {
        toast.error("Validation introuvable.");
        return;
      }

      const validationFile = await getFileValidationByEntity(
        "DiplomaValidation",
        validationId,
        buildPermissionContext(Resource.DIPLOME, Action.READ),
      );

      const temporaryUrl = validationFile?.data?.[0]?.temporaryUrl;

      if (!temporaryUrl) {
        toast.error("Support de validation introuvable.");
        return;
      }

      window.open(temporaryUrl, "_blank", "noopener,noreferrer");
    } catch (error: any) {
      // console.log("Erreur lors de l'ouverture du support de validation :", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const wizardSteps = [
    { number: 1, title: "Ancien annulé", checked: true },
    {
      number: 2,
      title: "Soumis à Validation",
      checked:
        diplomeDetail?.statut === "En cours de validation" ||
        diplomeDetail?.statut === "Validé" ||
        diplomeDetail?.statut === "Généré" ||
        (diplomeDetail?.id_old_diploma && diplomeDetail?.statut === "Annulé"),
    },
    {
      number: 3,
      title: "Validé",
      checked:
        diplomeDetail?.statut === "Validé" ||
        diplomeDetail?.statut === "Généré" ||
        (diplomeDetail?.id_old_diploma && diplomeDetail?.statut === "Annulé"),
    },
    {
      number: 4,
      title: "Diplôme Généré",
      checked:
        diplomeDetail?.statut === "Généré" ||
        (diplomeDetail?.id_old_diploma && diplomeDetail?.statut === "Annulé"),
    },
  ];

  const diplomeActionConfig = {
    Généré: {
      icon: "ti ti-file-check",
      iconClass: "bg-soft-danger text-danger",
      title: "Diplôme généré",
      description:
        "Vous pouvez annuler ce diplôme si une correction est nécessaire.",
      action: (
        <ProtectedBtnCancelDiplome cancelDiplomeAlert={cancelDiplomeAlert} />
      ),
    },
    Annulé: {
      icon: "ti ti-file-off",
      iconClass: "bg-soft-warning text-warning",
      title: "Diplôme annulé",
      description:
        "Vous pouvez régénérer ce diplôme après correction des erreurs.",
      action: (
        <ProtectedBtnRegenerateDiplome
          regenerateDiplomeAlert={regenerateDiplomeAlert}
        />
      ),
    },
  };

  const actionConfig =
    diplomeDetail?.statut === "Généré"
      ? diplomeActionConfig.Généré
      : diplomeDetail?.statut === "Annulé"
        ? diplomeActionConfig.Annulé
        : null;

  if (isLoading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="card">
            <div className="card-body py-5 text-center">
              <span
                className="spinner-border text-primary me-2"
                role="status"
              />
              Chargement du diplôme...
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!diplomeDetail) {
    return <div className="alert alert-info">Aucun diplôme trouvé.</div>;
  }

  // const diplome = diplomeDetail?.memory;
  // const memoryFile = memoryDetail.file || null;
  // const pvFile = memoryDetail.pvFile || null;

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* ===== Header ===== */}
        {/* <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                <div>
                    <h3 className="page-title mb-1">Bibliothèque Mémoire</h3>
                    <nav>
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                        <Link to={routes.studentDashboard}>Documents</Link>
                        </li>
                        <li className="breadcrumb-item">
                        <Link to={routes.memoryList}>Bibliothèque</Link>
                        </li>
                        <li className="breadcrumb-item active">Aperçu du document</li>
                    </ol>
                    </nav>
                </div>
                </div> */}

        {/* ===== Contenu ===== */}
        <div className="row g-3">
          {/* ===== PDF Viewer ===== */}
          <div className="col-lg-9">
            {diplomeDetail?.id_old_diploma ? (
              <>
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between flex-nowrap gap-2 overflow-auto pb-1">
                      {wizardSteps.map((step, index) => (
                        <div
                          key={step.number}
                          className="d-flex align-items-center flex-fill flex-shrink-0"
                          style={{ minWidth: 145 }}
                        >
                          <div className="d-flex align-items-center">
                            <span
                              className={`d-inline-flex align-items-center justify-content-center rounded-circle ${
                                step.checked
                                  ? "bg-success text-white"
                                  : "bg-light text-muted border"
                              }`}
                              style={{
                                width: 34,
                                height: 34,
                                fontWeight: 700,
                                flexShrink: 0,
                              }}
                            >
                              {step.checked ? (
                                <i className="ti ti-check" />
                              ) : (
                                step.number
                              )}
                            </span>
                            <div className="ms-2">
                              <div
                                className="fw-semibold text-dark"
                                style={{ fontSize: 13 }}
                              >
                                Étape {step.number}
                              </div>
                              <div
                                className="text-muted text-nowrap"
                                style={{ fontSize: 12 }}
                              >
                                {step.title}
                              </div>
                            </div>
                          </div>

                          {index < wizardSteps.length - 1 && (
                            <div
                              className="flex-grow-1 mx-2 d-none d-md-block"
                              style={{
                                height: 2,
                                minWidth: 18,
                                background: step.checked
                                  ? "#198754"
                                  : "#dee2e6",
                              }}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {diplomeDetail?.statut === "En Attente" ? (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ minHeight: "65vh" }}
                  >
                    <div
                      className="card border-0 shadow-sm w-100"
                      style={{ maxWidth: "520px" }}
                    >
                      <div className="card-body text-center py-5">
                        <i className="ti ti-file-off fs-1 text-muted mb-3 d-block" />
                        <h6 className="mb-1">Diplôme créer mais non soumis</h6>
                        <p className="text-muted mb-3">
                          Le diplôme a été regénéré avec succès, mais n'a pas
                          encore été soumis pour validation. Veuillez cliquer
                          sur le bouton ci-dessous pour soumettre le diplôme
                          pour validation. Une fois soumis, le diplôme passera
                          par les étapes de validation avant d'être
                          officiellement généré et disponible au téléchargement.
                        </p>
                        <ProtectedBtnSendDiplomeForValidation
                          validateDiplomeAlert={validateDiplomeAlert}
                        />
                      </div>
                    </div>
                  </div>
                ) : diplomeDetail?.statut === "En cours de validation" ? (
                  diplomeDetail?.Validation?.statut === "Rejeté" ? (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ minHeight: "65vh" }}
                    >
                      <div
                        className="card border-0 shadow-sm w-100"
                        style={{ maxWidth: "520px" }}
                      >
                        <div className="card-body text-center py-5">
                          <i className="ti ti-file-x fs-1 text-muted mb-3 d-block" />
                          <h6 className="mb-1">Validation du Diplôme Réfusé</h6>
                          <p className="text-muted mb-3">
                            Le diplôme a été refusé par{" "}
                            <strong>
                              {diplomeDetail?.Validation?.user_firstname}{" "}
                              {diplomeDetail?.Validation?.user_lastname}
                            </strong>{" "}
                            et n'est pas officiellement validé. Vous pouvez
                            contacter le service administratif pour plus
                            d'informations.
                          </p>

                          {/* <button className="btn btn-success" onClick={generateDiplomeAlert}>
                                                            <i className="ti ti-clipboard-data me-2" /> Générer le diplôme
                                                        </button> */}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ minHeight: "65vh" }}
                    >
                      <div
                        className="card border-0 shadow-sm w-100"
                        style={{ maxWidth: "520px" }}
                      >
                        <div className="card-body text-center py-5">
                          <i className="ti ti-file-off fs-1 text-muted mb-3 d-block" />
                          <h6 className="mb-1">
                            Diplôme en attente de validation
                          </h6>
                          <p className="text-muted mb-3">
                            Le diplôme a été soumis pour validation et est
                            actuellement en cours de validation. Veuillez
                            patienter pendant que le processus de validation est
                            en cours. Une fois validé, le diplôme sera
                            officiellement généré et disponible au
                            téléchargement.
                          </p>

                          {decisionParameter?.validator1?.id === userData?.id ||
                          decisionParameter?.validator2?.id === userData?.id ? (
                            <button
                              className="btn btn-success"
                              onClick={() => setShowValidationModal(true)}
                            >
                              <i className="ti ti-clipboard-data me-2" />{" "}
                              Valider le diplôme
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  )
                ) : diplomeDetail?.statut === "Validé" ? (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ minHeight: "65vh" }}
                  >
                    <div
                      className="card border-0 shadow-sm w-100"
                      style={{ maxWidth: "520px" }}
                    >
                      <div className="card-body text-center py-5">
                        <i className="ti ti-file-check fs-1 text-muted mb-3 d-block" />
                        <h6 className="mb-1">Diplôme validé</h6>
                        <p className="text-muted mb-3">
                          Le diplôme a été validé avec succès et est maintenant
                          officiellement validé. Vous pouvez lancer le processus
                          de génération.
                        </p>

                        <ProtectedBtnGenerateDiplome
                          generateDiplomeAlert={generateDiplomeAlert}
                        />
                      </div>
                    </div>
                  </div>
                ) : diplomeDetail?.statut === "Rejeté" ? (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ minHeight: "65vh" }}
                  >
                    <div
                      className="card border-0 shadow-sm w-100"
                      style={{ maxWidth: "520px" }}
                    >
                      <div className="card-body text-center py-5">
                        <i className="ti ti-file-check fs-1 text-muted mb-3 d-block" />
                        <h6 className="mb-1">Validation du Diplôme Réfusé</h6>
                        <p className="text-muted mb-3">
                          Le diplôme a été refusé par{" "}
                          <strong>
                            {diplomeDetail?.Validation?.user_firstname}{" "}
                            {diplomeDetail?.Validation?.user_lastname}
                          </strong>{" "}
                          et n'est pas officiellement validé. Vous pouvez
                          contacter le service administratif pour plus
                          d'informations.
                        </p>

                        {/* <button className="btn btn-success" onClick={generateDiplomeAlert}>
                                                            <i className="ti ti-clipboard-data me-2" /> Générer le diplôme
                                                        </button> */}
                      </div>
                    </div>
                  </div>
                ) : (
                  (diplomeDetail?.statut === "Généré" ||
                    diplomeDetail?.statut === "Annulé") && (
                    <div className="card">
                      <div className="card-body p-0">
                        {/* Toolbar */}
                        <div className="border-bottom p-2 d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-3">
                            {/* Bouton retour rond */}
                            <Link
                              to={`/diplomes/${idDecision}`} // Retour à la liste des diplômes de la décision
                              title="Retour"
                              className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: 36, height: 36 }}
                            >
                              <i className="ti ti-arrow-left fs-18" />
                            </Link>

                            {/* Icône PDF */}
                            <i className="ti ti-file-type-pdf text-danger fs-20" />

                            {/* Nom du fichier */}
                            <strong className="text-truncate">
                              {/* {memoryFile?.fileOriginalName || "Aucun document"} */}
                            </strong>
                          </div>

                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-light btn-sm"
                              disabled={!diplomeFile?.temporaryUrl}
                              onClick={(e) => {
                                e.preventDefault();
                                handleDownloadDiplomeFile();
                              }}
                            >
                              <i className="ti ti-download" />
                            </button>
                          </div>
                        </div>
                        {iframeSrc ? (
                          <>
                            {/* PDF iframe */}
                            <iframe
                              src={iframeSrc}
                              title="Mémoire PDF"
                              style={{
                                width: "100%",
                                height: "75vh",
                                border: "none",
                              }}
                            />
                          </>
                        ) : (
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{ minHeight: "65vh" }}
                          >
                            <div
                              className="card border-0 shadow-sm w-100"
                              style={{ maxWidth: "520px" }}
                            >
                              <div className="card-body text-center py-5">
                                <i className="ti ti-file-off fs-1 text-muted mb-3 d-block" />
                                <h6 className="mb-1">Fichier Introuvable</h6>
                                <p className="text-muted mb-3">
                                  Ajoutez le document du mémoire pour pouvoir le
                                  prévisualiser ici.
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                )}
              </>
            ) : (
              <div className="card h-100">
                <div className="card-body p-0">
                  {/* Toolbar */}
                  <div className="border-bottom p-2 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                      {/* Bouton retour rond */}
                      <Link
                        to={`/diplomes/${idDecision}`} // Retour à la liste des diplômes de la décision
                        title="Retour"
                        className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: 36, height: 36 }}
                      >
                        <i className="ti ti-arrow-left fs-18" />
                      </Link>

                      {/* Icône PDF */}
                      <i className="ti ti-file-type-pdf text-danger fs-20" />

                      {/* Nom du fichier */}
                      <strong className="text-truncate">
                        {/* {memoryFile?.fileOriginalName || "Aucun document"} */}
                      </strong>
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-light btn-sm"
                        disabled={!diplomeFile?.temporaryUrl}
                        onClick={(e) => {
                          e.preventDefault();
                          handleDownloadDiplomeFile();
                        }}
                      >
                        <i className="ti ti-download" />
                      </button>
                    </div>
                  </div>
                  {iframeSrc ? (
                    <>
                      {/* PDF iframe */}
                      <iframe
                        src={iframeSrc}
                        title="Mémoire PDF"
                        style={{
                          width: "100%",
                          height: "75vh",
                          border: "none",
                        }}
                      />
                    </>
                  ) : (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ minHeight: "65vh" }}
                    >
                      <div
                        className="card border-0 shadow-sm w-100"
                        style={{ maxWidth: "520px" }}
                      >
                        <div className="card-body text-center py-5">
                          <i className="ti ti-file-off fs-1 text-muted mb-3 d-block" />
                          <h6 className="mb-1">Fichier Introuvable</h6>
                          <p className="text-muted mb-3">
                            Ajoutez le document du mémoire pour pouvoir le
                            prévisualiser ici.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* ===== Sidebar détails ===== */}
          <div className="col-lg-3">
            <div className="card h-100">
              <div className="card-header">
                {/* Titre */}
                <div className="d-flex align-items-start justify-content-between gap-2">
                  <h5 className="mb-1">Diplôme N°{diplomeDetail?.number}</h5>
                </div>
              </div>
              <div className="card-body">
                {/* Infos */}
                <ul className="list-unstyled mb-4">
                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-user me-2 mt-1" />
                    <div>
                      <small className="text-muted">N° Matricule</small>
                      <div className="fw-semibold text-dark">
                        {diplomeDetail?.student?.matricule}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-user me-2 mt-1" />
                    <div>
                      <small className="text-muted">Étudiant</small>
                      <div className="fw-semibold text-dark">
                        {diplomeDetail?.student?.prenom}{" "}
                        {diplomeDetail?.student?.nom}
                      </div>
                    </div>
                  </li>

                  {/* <li className="d-flex align-items-start mb-3">
                                        <i className="ti ti-user-check me-2 mt-1" />
                                        <div>
                                            <small className="text-muted">Date et Lieu de naissance</small>
                                            <div className="fw-semibold text-dark">{new Date(diplomeDetail?.student?.birthday).toLocaleDateString("fr-FR")} à {diplomeDetail?.student?.place_birth}</div>
                                        </div>
                                    </li> */}

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-users me-2 mt-1" />
                    <div>
                      <small className="text-muted">Classes</small>
                      <div className="fw-semibold text-dark">
                        {diplomeDetail?.Parcour.label_cycle} -{" "}
                        {diplomeDetail?.Parcour.titre}
                      </div>
                      <div className="fw-semibold text-dark">
                        {diplomeDetail?.last_registration?.abb_level}{" "}
                        {diplomeDetail?.last_registration?.label_classe}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-school me-2 mt-1" />
                    <div>
                      <small className="text-muted">Note / Mention</small>
                      <div className="fw-semibold text-dark">
                        {diplomeDetail?.noteParcours} -{" "}
                        {diplomeDetail?.MentionCycle}{" "}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-calendar me-2 mt-1" />
                    <div>
                      <small className="text-muted">Année académique</small>

                      <div className="fw-semibold text-dark">
                        {diplomeDetail?.last_registration?.label_academicYear}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-clock me-2 mt-1" />
                    <div>
                      <small className="text-muted">Date de génération</small>
                      <div className="fw-semibold text-dark">
                        {new Date(
                          diplomeDetail?.date_generation,
                        ).toLocaleDateString("fr-FR")}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-clock me-2 mt-1" />
                    <div>
                      <small className="text-muted">Statut</small>
                      <div className="fw-semibold">
                        {(() => {
                          const statutBadge = getDiplomeStatutBadge(
                            diplomeDetail?.statut,
                          );

                          return (
                            <span
                              className={`pt-1 pb-1 badge ${statutBadge.className}`}
                              style={{ fontSize: 12 }}
                            >
                              {statutBadge.icon} {statutBadge.label}
                            </span>
                          );
                        })()}
                      </div>
                    </div>
                  </li>

                  {diplomeDetail?.Validation?.id && (
                    <li className="d-flex align-items-start mb-3">
                      <i
                        className={`${getDiplomeValidationBadge(diplomeDetail.Validation.statut).icon} me-2 mt-1`}
                      />
                      <div className="w-100">
                        <small className="text-muted">
                          Validation du diplôme
                        </small>
                        {(() => {
                          const validationBadge = getDiplomeValidationBadge(
                            diplomeDetail.Validation.statut,
                          );

                          return (
                            <div
                              className={`border rounded p-2 mt-1 ${validationBadge.cardClassName}`}
                            >
                              <div className="d-flex align-items-center justify-content-between gap-2">
                                <div className="fw-semibold text-dark">
                                  {diplomeDetail.Validation.user_firstname}{" "}
                                  {diplomeDetail.Validation.user_lastname}
                                </div>

                                <span
                                  className={`badge ${validationBadge.className}`}
                                  style={{ fontSize: 12 }}
                                >
                                  <i
                                    className={`${validationBadge.icon} me-1`}
                                  />
                                  {validationBadge.label}
                                </span>
                              </div>

                              <div
                                className="text-muted"
                                style={{ fontSize: 12 }}
                              >
                                {diplomeDetail.Validation.user_jobFunction ||
                                  "Poste non renseigné"}
                              </div>

                              {diplomeDetail?.Validation?.createdAt && (
                                <div className="mt-2" style={{ fontSize: 12 }}>
                                  <span className="text-muted">
                                    {validationBadge.dateLabel} :{" "}
                                  </span>
                                  <span className="fw-semibold text-dark">
                                    {new Date(
                                      diplomeDetail?.Validation?.createdAt,
                                    ).toLocaleDateString("fr-FR")}
                                  </span>
                                </div>
                              )}

                              <div className="mt-2" style={{ fontSize: 12 }}>
                                <span className="text-muted">
                                  Observation :{" "}
                                </span>
                                <span className=" text-dark">
                                  {diplomeDetail.Validation.observation || "--"}
                                </span>
                              </div>

                              <button
                                type="button"
                                className={`btn ${validationBadge.supportBtnClassName} btn-sm d-inline-flex align-items-center mt-2`}
                                onClick={handleGetValidationSupport}
                              >
                                <i className="ti ti-paperclip me-1" />
                                Voir le support
                              </button>
                            </div>
                          );
                        })()}
                      </div>
                    </li>
                  )}

                  {diplomeDetail?.statut === "Annulé" && (
                    <li className="d-flex align-items-start mb-3">
                      <i className="ti ti-x me-2 mt-1" />
                      <div>
                        <small className="text-muted">
                          Raison Annulation : {diplomeDetail?.reason_annulation}
                        </small>
                        <div className="fw-semibold text-dark">
                          {diplomeDetail?.observation_annulation}
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>

              <div className="card-footer p-0">
                <div className="d-flex flex-column align-items-center justify-content-center text-center p-3 border border-dashed rounded bg-light">
                  {actionConfig ? (
                    <>
                      <span
                        className={`${actionConfig.iconClass} avatar avatar-lg mb-3 rounded-circle d-flex align-items-center justify-content-center`}
                      >
                        <i className={`${actionConfig.icon} fs-24`} />
                      </span>

                      <h6 className="mb-1">{actionConfig.title}</h6>
                      <p className="text-muted fs-13 mb-3">
                        {actionConfig.description}
                      </p>

                      {actionConfig.action}
                    </>
                  ) : (
                    <>
                      <span className="bg-soft-secondary text-muted avatar avatar-lg mb-3 rounded-circle d-flex align-items-center justify-content-center">
                        <i className="ti ti-file-info fs-24" />
                      </span>

                      <p className="text-muted fs-13 mb-0">
                        Aucune action disponible pour ce diplôme.
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* === Modale d'édition === */}
      <CancelDiplome
        show={showCancelModal}
        diplome={diplomeDetail}
        onClose={() => setShowCancelModal(false)}
        onSaved={() => fetchDiplomeDetails(true, ["status", "details"])}
      />
      <DiplomeValidationModal
        show={showValidationModal}
        idDecision={idDecision}
        idDiplome={id}
        onClose={() => setShowValidationModal(false)}
        onSaved={() => fetchDiplomeDetails(true, ["status"])}
      />
    </div>
  );
};

export default DiplomeDetails;
